import { render, staticRenderFns } from "./UserAssignedRegionDropdown.vue?vue&type=template&id=6bdac240"
import script from "./UserAssignedRegionDropdown.vue?vue&type=script&lang=js"
export * from "./UserAssignedRegionDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports